import { render, staticRenderFns } from "./assign-editor.dialog.vue?vue&type=template&id=49b0d9ba&scoped=true"
import script from "./assign-editor.dialog.vue?vue&type=script&lang=js"
export * from "./assign-editor.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b0d9ba",
  null
  
)

export default component.exports